/** The canonical name for this component */
export const canonicalName = 'choice-button';
/** A record of valid properties for the FsChoiceButton alignment property */
export const fsChoiceButtonAlignment = {
    left: 'left',
    center: 'center'
};
/** A record of valid properties for the FsChoiceButton type property */
export const choiceButtonType = {
    checkbox: 'checkbox',
    radio: 'radio'
};
/** Acts as the default configuration for instances of ChoiceButton */
export const fsChoiceButtonDefaults = {
    alignment: 'center',
    compact: false,
    type: 'radio',
    selected: false
};
/** All possible options for the choice button alignment */
export const fsChoiceButtonAlignments = ['center', 'left'];
/** All possible options for the choice button alignment */
export const fsChoiceButtonTypes = ['checkbox', 'radio'];
//# sourceMappingURL=ChoiceButton.js.map